import styled from 'styled-components'

export const StyledList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0;
  padding: 0;
  list-style: none;

  .active-ticket {
    display: flex;
    flex-direction: column;
    gap: 4px;
    color: ${ ({ theme }) => theme.colors.black };

    & + .active-ticket {
      padding-top: 16px;
      border-top: 2px solid ${ ({ theme }) => theme.colors.greyLight };
    }
  }

  .service {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }

  .service-name,
  .affair {
    font-size: 16px;
    font-weight: 700;
  }

  .expedition-time {
    font-size: 14px;
    color: ${ ({ theme }) => theme.colors.greyDark };
  }

  .public-message {
    margin: 0;
    font-size: 16px;
    white-space: pre-line;
  }
`

export const StyledBanner = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 16px 0;
  padding: 16px;
  border: 2px solid ${ ({ theme }) => theme.colors.red };
  border-radius: 8px;
  background-color: ${ ({ theme }) => theme.colors.mediumRed };

  header {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 700;
    color: ${ ({ theme }) => theme.colors.red };

    img {
      width: 24px;
      height: 24px;
    }
  }
`
